var auth = require('./auth');

require('./components/register-form');
require('./components/login-form');

$(function () {
    $('form[role=ycgame-register-form]').ycgameRegisterForm();
    $('form[role=ycgame-login-form]').ycgameLoginForm();

    $(document).on('click', '[role=ycgame-logout-btn]', function (e) {
        e.preventDefault();
        auth.logout();
    });
    auth.bind(auth.EVENTS.LOGIN, function () {
        $(document).find('[role=ycgame-login-renderer]').ycgameTmplRender();
    });
    auth.bind(auth.EVENTS.LOGOUT, function () {
        $(document).find('[role=ycgame-login-renderer]').trigger('tmpl-rollback');
    });
});

module.exports = {
    auth: auth
};


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0